<style lang="scss">
  @import '../resources/scss/annual_reports.scss';
</style>

<script lang="ts">
  import type AnnualReport from '../api/rest/directus-cms/about/models/AnnualReport'

  export let annualReport: AnnualReport
</script>

<section id="annual-reports">
  {#if annualReport}
    <div class="container-fluid bg_secondary_i py-section">
      <div class="container-xxl">
        <div class="row">
          <div class="col-12">
            <h1 class="text-primary-orange mb-0 pb-1">{annualReport.title}</h1>
            <div class="row max-cols-row">
              {#each annualReport.items as item}
                <div class="col pt-3">
                  <a
                    class="text-primary-orange h4"
                    href={item.url
                      ? item.url
                      : item.file?.fullUrl
                      ? item.file?.fullUrl
                      : '#'}
                    target="_blank"
                    >{item.title ?? ''}
                  </a>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</section>
